import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((_theme) => ({
  root: {
    textAlign: 'center',
  },
}));

export default useStyles;
